/* ============================================================
   MARELLES — JS du thème (vanilla, sans dépendance)
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.marellesConfig || { freeShippingCents: 7000, moneyFormat: '{{amount_with_comma_separator}} €' };

  /* ── Helpers ── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var format = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function showToast(message) {
    var toast = qs('#toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }
  window.marellesToast = showToast;

  /* ── Header : ombre au scroll ── */
  var header = qs('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Recherche header ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (toggle) {
      var bar = qs('[data-search-bar]');
      if (bar) {
        bar.hidden = !bar.hidden;
        if (!bar.hidden) {
          var input = qs('input', bar);
          if (input) input.focus();
        }
      }
    }
    if (e.target.closest('[data-search-close]')) {
      var bar2 = qs('[data-search-bar]');
      if (bar2) bar2.hidden = true;
    }
  });

  /* ── Drawer menu mobile ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      var drawer = qs('[data-mobile-drawer]');
      if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-menu-close]')) {
      var drawer2 = qs('[data-mobile-drawer]');
      if (drawer2) { drawer2.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  /* ── Drawer filtres (collection, mobile) ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-open]')) {
      var d = qs('[data-filters-drawer]');
      if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-filters-close]')) {
      var d2 = qs('[data-filters-drawer]');
      if (d2) { d2.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });

  /* ── Tri collection ── */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    }
  });

  /* ============================================================
     PANIER (AJAX)
     ============================================================ */
  function openCartDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCartDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  window.marellesOpenCart = openCartDrawer;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openCartDrawer); }
    if (e.target.closest('[data-cart-close]')) closeCartDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      var md = qs('[data-mobile-drawer]');
      if (md) md.classList.remove('is-open');
      var fd = qs('[data-filters-drawer]');
      if (fd) fd.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  function updateCartCount(cart) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
  }

  function renderCartDrawer(cart) {
    var itemsWrap = qs('[data-cart-items]');
    var foot = qs('[data-cart-foot]');
    var shipWrap = qs('[data-shipping-bar]');
    if (!itemsWrap) return;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p class="cart-drawer__empty-title">' + (itemsWrap.dataset.emptyTitle || 'Votre panier est vide') + '</p>' +
        '<p class="cart-drawer__empty-sub">' + (itemsWrap.dataset.emptySub || '') + '</p>' +
        '<a href="' + (itemsWrap.dataset.shopUrl || '/collections/all') + '" class="btn btn--primary">' + (itemsWrap.dataset.emptyCta || 'Découvrir la boutique') + '</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      if (shipWrap) shipWrap.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;
    if (shipWrap) shipWrap.hidden = false;

    var html = cart.items.map(function (item) {
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var props = [];
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (k.charAt(0) !== '_' && item.properties[k]) props.push(k + ' : ' + item.properties[k]);
        });
      }
      return (
        '<div class="cart-item" data-line-key="' + item.key + '">' +
          '<a class="cart-item__media" href="' + item.url + '">' +
            (item.image
              ? '<img src="' + item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_200x$1$2') + '" alt="" loading="lazy">'
              : '') +
          '</a>' +
          '<div class="cart-item__body">' +
            '<a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
            (variantTitle ? '<p class="cart-item__variant">' + variantTitle + '</p>' : '') +
            (props.length ? '<p class="cart-item__variant">' + props.join(' · ') + '</p>' : '') +
            '<div class="cart-item__row">' +
              '<div class="cart-item__qty">' +
                '<button type="button" data-qty-change="-1" aria-label="Diminuer">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-change="1" aria-label="Augmenter">+</button>' +
              '</div>' +
              '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-item__remove" data-remove-item>' + (itemsWrap.dataset.removeText || 'Retirer') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    itemsWrap.innerHTML = html;

    var subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);

    /* Barre livraison offerte */
    if (shipWrap) {
      var threshold = cfg.freeShippingCents || 7000;
      var remaining = threshold - cart.items_subtotal_price;
      var fill = qs('.shipping-bar__fill', shipWrap);
      var text = qs('.shipping-bar__text', shipWrap);
      var pct = Math.min(100, Math.round((cart.items_subtotal_price / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (remaining > 0) {
          text.innerHTML = (shipWrap.dataset.remainingText || 'Plus que <strong>{amount}</strong> pour la livraison offerte').replace('{amount}', '<strong>' + formatMoney(remaining) + '</strong>');
        } else {
          text.innerHTML = '<strong>' + (shipWrap.dataset.reachedText || 'Livraison offerte ! 🎉') + '</strong>';
        }
      }
    }
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        renderCartDrawer(cart);
        return cart;
      })
      .catch(function () {});
  }

  window.marellesRefreshCart = refreshCart;

  /* Quantités / suppression dans le drawer */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-remove-item]');
    if (!qtyBtn && !removeBtn) return;
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var newQty = 0;
    if (qtyBtn) {
      var current = parseInt(qs('.cart-item__qty span', line).textContent, 10) || 1;
      newQty = Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart);
        renderCartDrawer(cart);
      });
  });

  /* Ajout au panier via formulaire produit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form);
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || data.message || 'Erreur'); });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Ajout rapide depuis carte produit */
  document.addEventListener('click', function (e) {
    var quickBtn = e.target.closest('[data-quick-add]');
    if (!quickBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = quickBtn.getAttribute('data-quick-add');
    if (!variantId) return;
    quickBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw new Error(data.description || data.message || 'Erreur'); });
        return r.json();
      })
      .then(function () {
        quickBtn.classList.add('is-added');
        quickBtn.textContent = cfg.cartAddedText || 'Ajouté !';
        setTimeout(function () {
          quickBtn.classList.remove('is-added');
          quickBtn.textContent = cfg.cartAddText || 'Ajouter au panier';
        }, 1800);
        return refreshCart();
      })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { quickBtn.disabled = false; });
  });

  /* ============================================================
     FICHE PRODUIT
     ============================================================ */
  /* Galerie */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-index]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var main = qs('[data-main-image]', gallery);
    var src = thumb.getAttribute('data-full-src');
    if (main && src) {
      main.classList.add('is-fading');
      setTimeout(function () {
        main.src = src;
        var srcset = thumb.getAttribute('data-full-srcset');
        if (srcset) main.setAttribute('srcset', srcset);
        main.onload = function () { main.classList.remove('is-fading'); };
      }, 180);
    }
    qsa('[data-thumb-index]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });
/* Swipe mobile galerie produit */
document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  var mainImage = gallery.querySelector('[data-main-image]');
  if (!mainImage) return;

  var startX = 0;
  var startY = 0;

  mainImage.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  mainImage.addEventListener('touchend', function (e) {
    if (!e.changedTouches.length) return;

    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;
    var diffX = endX - startX;
    var diffY = endY - startY;

    /* Ignore les petits mouvements et le défilement vertical */
    if (Math.abs(diffX) < 50 || Math.abs(diffX) < Math.abs(diffY)) return;

    var thumbs = Array.from(gallery.querySelectorAll('[data-thumb-index]'));
    if (!thumbs.length) return;

    var currentIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });

    if (currentIndex < 0) currentIndex = 0;

    var nextIndex = diffX < 0 ? currentIndex + 1 : currentIndex - 1;

    if (nextIndex >= 0 && nextIndex < thumbs.length) {
      thumbs[nextIndex].click();
    }
  }, { passive: true });
});
  /* Quantité fiche produit */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    var wrap = btn.closest('.qty-picker');
    var input = qs('input', wrap);
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.getAttribute('data-qty-btn'), 10);
    input.value = Math.max(1, val);
  });

  /* Variantes (pills) */
  function initVariantPicker() {
    var picker = qs('[data-variant-picker]');
    if (!picker) return;
    var variants = JSON.parse(qs('[data-variants-json]').textContent);
    var form = qs('form[data-product-form]');
    var idInput = form ? qs('input[name="id"]', form) : null;

    function selectedOptions() {
      var opts = [];
      qsa('[data-option-index]', picker).forEach(function (group) {
        var sel = qs('.option-pill.is-selected', group);
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = sel ? sel.getAttribute('data-value') : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant(selectedOptions());
      var priceEl = qs('[data-product-price]');
      var compareEl = qs('[data-product-compare]');
      var stockEl = qs('[data-product-stock]');
      var addBtn = qs('[data-add-button]');
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailableText || 'Indisponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      var mainImage = qs('[data-main-image]');
if (mainImage && variant.featured_image && variant.featured_image.src) {
  mainImage.src = variant.featured_image.src;
  mainImage.removeAttribute('srcset');
}
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      var available = variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? (addBtn.dataset.addText || 'Ajouter au panier') : (addBtn.dataset.soldoutText || 'Indisponible');
      }
      if (stockEl) {
        stockEl.innerHTML = available
          ? '<span class="dot dot--in"></span> <span class="label--in">' + (stockEl.dataset.inText || 'En stock') + '</span> <span class="sub">' + (stockEl.dataset.inSub || '') + '</span>'
          : '<span class="dot dot--out"></span> <span class="label--out">' + (stockEl.dataset.outText || 'Momentanément indisponible') + '</span>';
      }
      /* URL avec variant */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.option-pill');
      if (!pill) return;
      var group = pill.closest('[data-option-index]');
      qsa('.option-pill', group).forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      var label = qs('[data-selected-value]', group);
      if (label) label.textContent = pill.getAttribute('data-value');
      updateUI();
    });
  }
  initVariantPicker();

  /* ============================================================
     CARROUSEL AVIS
     ============================================================ */
  function initReviews() {
    var section = qs('[data-reviews]');
    if (!section) return;
    var cards = JSON.parse(qs('[data-reviews-json]', section).textContent);
    var total = cards.length;
    if (!total) return;
    var active = 0;
    var timer = null;

    function cardHTML(r) {
      var stars = '';
      for (var i = 0; i < (r.stars || 5); i++) {
        stars += '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.26L21.5 9.27l-4.75 4.28L18.18 20 12 16.6 5.82 20l1.43-6.45L2.5 9.27l6.6-1.01L12 2z"/></svg>';
      }
      return (
        '<div class="review-card">' +
          '<div class="review-card__stars">' + stars + '</div>' +
          '<p class="review-card__text">&ldquo;' + r.text + '&rdquo;</p>' +
          '<div class="review-card__author">' +
            '<div class="review-card__avatar">' + (r.name ? r.name.charAt(0) : '•') + '</div>' +
            '<p class="review-card__name">' + r.name + '</p>' +
          '</div>' +
        '</div>'
      );
    }

    function render() {
      var slots = qsa('[data-review-slot]', section);
      var indices = [(active - 1 + total) % total, active, (active + 1) % total];
      slots.forEach(function (slot, pos) {
        var idx = indices[pos];
        slot.innerHTML = cardHTML(cards[idx]);
        slot.classList.toggle('is-center', pos === 1);
        slot.classList.toggle('is-side', pos !== 1);
      });
      var mobile = qs('[data-review-mobile]', section);
      if (mobile) mobile.innerHTML = cardHTML(cards[active]);
      qsa('[data-review-dot]', section).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    function go(dir) { active = (active + dir + total) % total; render(); }
    function startTimer() { stopTimer(); timer = setInterval(function () { go(1); }, 5000); }
    function stopTimer() { if (timer) clearInterval(timer); }

    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-review-prev]')) go(-1);
      if (e.target.closest('[data-review-next]')) go(1);
      var dot = e.target.closest('[data-review-dot]');
      if (dot) { active = parseInt(dot.getAttribute('data-index'), 10); render(); }
    });
    section.addEventListener('mouseenter', stopTimer);
    section.addEventListener('mouseleave', startTimer);

    render();
    if (total > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) startTimer();
  }
  initReviews();

  /* Init compteur panier au chargement */
  refreshCart();
})();
